import React from "react";

import ProgramBeyondBorders from "../../../components/program/journeys/programBeyondBorders";
import ProgramHighlights from "../../../components/program/journeys/programHighlights";
import ProgramJourneysItinerary from "../../../components/program/journeys/programJourneysItinerary";
import ProgramKeyMessaging from "../../../components/program/journeys/programKeyMessaging";
import ProgramImpact from "../../../components/program/programImpact";
import CollapsibleWrapper from "../../../components/shared/collapsibleWrapper";
import DownloadBanner from "../../../components/shared/downloadBanner";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import brochureImage from "../../../images/program/under18-brochure.png";
import { stripHtmlTags } from "../../../utils/commonFunctions";
import Image from "../../image";
import ProgramDoGoodBetter from "../journeys/programDoGoodBetter";
import ProgramImpactfulTravel from "../journeys/programImpactfulTravel";
import ProviderBiography from "./providerBiography";
import WhatsIncludedExcluded from "./whatsIncludedExcluded";

const ProgramInfo = ({
  programDetails,
  excerpt,
  sharedDetails,
  testimonials,
  program,
  programImpact,
  travelDetails,
  providerBiographyDetail = "",
  groupInstitute = "",
  programTitle = "",
  programDuration = "",
  programSDGIcons = [],
  setBrochureDownloadModal,
  brochureDownloadFile,
  layout = "",
  outerContainerClass = "w-full mx-auto flex items-center justify-center relative overflow-hidden",
  innerContainerClass = "summary-section justify-center w-11/12 py-12 sm:py-16 flex gap-10 flex-wrap sm:flex-nowrap sm:w-10/12 2xl:w-full",
  innerContainerChildClass = "w-full md:sticky-left-section mr-auto md:!pr-4",
  programAccommodationGallery = <></>
}) => {
  const breakpoint = useBreakpoint();
  const programType =
    programDetails.programTypes && programDetails.programTypes.length
      ? programDetails.programTypes.map((pgmType) => pgmType.slug.toLowerCase())
      : [];

  const includesList =
    programDetails?.includes?.length > 0
      ? programDetails?.includes?.map((include) => {
          return {
            title: include.include,
            description: include.desc
          };
        })
      : [];

  const excludesList =
    programDetails?.excludes?.length > 0
      ? programDetails?.excludes?.map((exclude) => {
          return {
            title: exclude.exclude,
            description: exclude.desc
          };
        })
      : [];

  const whatsincludedDesc = programDetails?.ingoWhatsincludedDesc ?? "";
  const whatsincludedTitle = programDetails?.ingoWhatsincludedTitle ?? "";
  const whatsnotincludedDesc = programDetails?.ingoWhatsnotincludedDesc ?? "";
  const whatsnotincludedSubtitle =
    programDetails?.ingoWhatsnotincludedSubtitle ?? "";
  const whatsnotincludedTitle = programDetails?.ingoWhatsnotincludedTitle ?? "";

  const ingoVerificationCertificateUrl =
    programDetails?.ingoVerificationCertificateUrl ?? "#";

  const providerBiography = providerBiographyDetail || {
    title: programDetails?.ingoBioName ?? "",
    description: programDetails?.ingoBioDesc ?? "",
    img:
      programDetails?.ingoBioAvatar?.localFile?.publicURL ??
      programDetails?.ingoBioAvatar?.sourceUrl,
    experience: programDetails?.ingoBioExperience ?? ""
  };

  const genericConfig =
    sharedDetails?.globalProgramConfig?.acfGenericGlobalConfig ?? [];

  const downloadBannerTitle =
    genericConfig?.teenBrochureTitle ?? "Under 18s brochure";
  const downloadBannerDescription =
    genericConfig?.teenBrochureDescription ??
    "We've got amazing programs tailored for young adults.";
  const downloadBannerLink = genericConfig?.teenBrochureDownloadLink ?? "";

  const programHighlights = {
    heading: programDetails?.journeysHighlightHeading ?? "",
    featured_image: programDetails?.journeysHighlightImage ?? "",
    title: programDetails?.journeysHighlightSectionTitle ?? "",
    sub_heading: programDetails?.journeysHighlightSubHeading ?? "",
    highlights: programDetails?.journeysHighlights ?? []
  };

  const programItineraryDetails = {
    title: programDetails?.journeysItineraryTitle ?? "",
    description: programDetails?.journeysItineraryDesc ?? "",
    sub_section_title: programDetails?.journeysItinerarySubsectionTitle ?? "",
    sub_section_desc: programDetails?.journeysItinerarySubsectionDesc ?? "",
    itinerary_file: programDetails?.journeysItineraryFile ?? "",
    itinerary_list: programDetails?.journeysItinerary ?? []
  };

  const programBeyondBordersImg = programDetails?.beyondBordersImage ?? "";

  return (
    <>
      <section className={outerContainerClass}>
        <section className={innerContainerClass}>
          <div className={innerContainerChildClass}>
            <div className="py-4 border-b-1 border-gray-generic dark:border-black-quaternary hidden">
              <div className="flex flex-col 2xl:w-full">
                <h2
                  className="program-title dark:text-gray-dark leading-10 dark:font-bold 2xl:w-full"
                  dangerouslySetInnerHTML={{
                    __html: programTitle
                  }}
                />
                <div className="flex gap-6 py-4 items-center">
                  <div className="durations font-semibold text-black-lighter dark:text-gray-dark">
                    <span className="font-normal">Durations: </span>
                    {programDuration}
                  </div>

                  <div className="flex gap-2 sm:gap-8">
                    {programSDGIcons?.map((sdgIcon, idx) => {
                      return (
                        <div
                          key={`sdgIcon-${idx}`}
                          className="flex gap-2 sm:gap-3 icon-wrapper justify-items-center items-center text-black-lighter dark:text-gray-dark"
                        >
                          <Image
                            imageClass={
                              "w-7 h-7 block object-cover object-center bg-gray-dark"
                            }
                            image={sdgIcon?.icon}
                            sourceUrl={sdgIcon?.icon?.sourceUrl}
                          />
                          <div
                            className="text-black-lighter dark:text-gray-dark uppercase font-semibold"
                            dangerouslySetInnerHTML={{
                              __html: ["sdg", sdgIcon?.title].join(" ")
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            {excerpt && excerpt?.length > 0 && (
              <div className="pt-0 pb-10">
                <h6
                  className="font-light text-generic-text dark:font-bold text-xl md:text-xlrg-sm dark:text-white pb-4"
                  dangerouslySetInnerHTML={{ __html: "The project" }}
                />
                <CollapsibleWrapper
                  desc={excerpt}
                  summary={
                    [
                      stripHtmlTags(excerpt)?.slice(
                        0,
                        breakpoint === "xs" ? 200 : 550
                      ),
                      "..."
                    ].join("") ?? excerpt
                  }
                  descStyle="text-generic-text dark:text-gray-generic text-mob sm:text-base"
                  btnStyle="underline underline-offset-2 pt-2 text-generic-text dark:text-white text-mob font-bold sm:text-sm flex items-center gap-2 hover:no-underline"
                  wrapperContainer="ingo-overview inline tab-content_html"
                  visibleLength={breakpoint === "xs" ? 200 : 550}
                  visibleLines={"none"}
                  type={"both"}
                />
              </div>
            )}

            {programImpact?.list && programImpact?.list.length > 0 && (
              <div className="block sm:hidden">
                <ProgramImpact programImpact={programImpact} />
              </div>
            )}

            {layout === "journeys" && (
              <>
                <ProgramKeyMessaging />
                <ProgramHighlights highlights={programHighlights} />
                <ProgramJourneysItinerary
                  itineraryDetails={programItineraryDetails}
                  setBrochureDownloadModal={setBrochureDownloadModal}
                />

                <ProgramImpactfulTravel />
                <ProgramDoGoodBetter />

                <div className="border-t border-gray-generic dark:border-black-quaternary my-14" />

                {providerBiography?.name && (
                  <ProviderBiography
                    providerBiography={providerBiography}
                    layout={"journeys"}
                    bioSubHeadingClass="sm:flex pb-1 font-normal text-gray-nonary"
                    containerClass="bg-generic-bg md:border-l-[6px] md:border-l-red-light p-4 sm:px-10 sm:py-16"
                    containerInnerClass="flex-col gap-10 sm:relative sm:items-start md:grid md:grid-flow-col"
                    imgContainerClass="h-full w-full relative"
                    contentClass="gap-1 sm:gap-2"
                    bioExperienceClass="pt-3 sm:pt-0 text-gray-nonary"
                    imgClass="w-full rounded-md"
                  />
                )}
                <ProgramBeyondBorders featuredImage={programBeyondBordersImg} />
                {programAccommodationGallery}
              </>
            )}

            {programType.includes("under-18") && downloadBannerLink && (
              <DownloadBanner
                featuredImage={brochureImage}
                displayTitle={downloadBannerTitle}
                displayDescription={downloadBannerDescription}
                ctaLink={downloadBannerLink}
                ctaLabel="Download"
                target={"_gviblank"}
              />
            )}

            {!layout === "journeys" && brochureDownloadFile && (
              <div className="pt-0 pb-10 sm:w-2/3">
                <button
                  className="flex justify-center w-full sm:w-auto py-2 px-6 border border-black-lighter dark:border-white rounded-xxxxl dark:rounded-sm text-[16px] sm:text-base sm:justify-around !text-generic-text dark:!text-white visited:text-generic-text hover:border-0 hover:bg-black-lighter hover:!text-white dark:hover:bg-white dark:hover:border-0 dark:hover:!text-generic-text group"
                  onClick={() => setBrochureDownloadModal(true)}
                >
                  Download brochure
                </button>
              </div>
            )}

            {/* <ProgramVerification reportUrl={ingoVerificationCertificateUrl} /> */}

            {(includesList?.length > 0 || excludesList?.length > 0) && (
              <WhatsIncludedExcluded
                includesList={includesList}
                excludesList={excludesList}
                whatsincludedDesc={whatsincludedDesc}
                whatsincludedTitle={whatsincludedTitle}
                whatsnotincludedDesc={whatsnotincludedDesc}
                whatsnotincludedSubtitle={whatsnotincludedSubtitle}
                whatsnotincludedTitle={whatsnotincludedTitle}
              />
            )}

            {/* {providerBiographyDetail?.name && (
              <ProviderBiography providerBiography={providerBiographyDetail} />
            )} */}
          </div>
        </section>
      </section>
    </>
  );
};

export default ProgramInfo;
